import { Avatar, AvatarProps } from '@doveit/bricks';
import React from 'react';

export type UserAvatarProps = Omit<AvatarProps, 'color' | 'icon'>;

export const UserAvatar: React.FC<UserAvatarProps> = (props) => (
  <Avatar {...props} />
);

export default UserAvatar;
